// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

const isCampaignStats = objectOf({
  campaign_id: string,
  campaign_name: string,
  template_id: string,
  template_name: string,
  planned_volume: number,
  status: string,
  sent: number,
  delivered: number,
  bounced: number,
  opened: number,
  unique_opens: number,
  clicked: number,
  unsubscribed: number,
  spam_reports: number,
  delivery_rate: number,
  open_rate: number,
  unique_open_rate: number,
  spam_complaint_rate: number,
});

const isAnalyticsByDay = objectOf({
  date: string,
  planned_volume: number,
  adjustment_made: boolean,
  campaign_stats: arrayOf(isCampaignStats),
});

export const isEmailIpWarmingCampaignStatsResult = objectOf({
  ip_warming_plan_id: string,
  plan_status: string,
  analytics_by_day: arrayOf(isAnalyticsByDay),
});
